import { vModelCheckbox as _vModelCheckbox, createElementVNode as _createElementVNode, withDirectives as _withDirectives, normalizeClass as _normalizeClass, renderSlot as _renderSlot, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-5e3792da"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "a-checkbox" }
const _hoisted_2 = ["value"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("label", _hoisted_1, [
    _withDirectives(_createElementVNode("input", {
      "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.checkedData) = $event)),
      type: "checkbox",
      class: "a-checkbox__body",
      value: _ctx.dataValue,
      onChange: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.changeCheckbox && _ctx.changeCheckbox(...args)))
    }, null, 40, _hoisted_2), [
      [_vModelCheckbox, _ctx.checkedData]
    ]),
    _createElementVNode("span", {
      class: _normalizeClass(["a-checkbox__icon", _ctx.errorClassName])
    }, null, 2),
    _renderSlot(_ctx.$slots, "default", {}, undefined, true)
  ]))
}